import { InvoiceFormConfig } from '../types';
import { isTaxExcludedFromQuotesByBuyer } from '../../../utils/QuoteDataAdapter';
import {
	laborConfig,
	partsConfig,
	equipmentConfig,
	travelConfig,
	freightConfig,
	miscellaneousConfig,
} from '../../SupplierInvoiceFormNew/CostSectionConfigs';

// Incurred cost is a simple (description + amount) line item, identical in shape
// to the miscellaneous section — only the label differs.
const incurredConfig = {
	...miscellaneousConfig,
	label: 'Incurred Cost',
};

interface CreateQuoteConfigOptions {
	redirectForwardUrl?: string;
	creating?: boolean;
	updating?: boolean;
	createErrors?: string[];
	updateErrors?: string[];
	onSuccess?: (record: any) => void;
	parsedDataSnapshot?: any;
	// The quote work order check the uploader chose to continue past, and the extraction it refers to.
	workOrderCheck?: any;
	rawParsedData?: any;
	onError?: (error: any) => void;
	onReset?: () => void;
	disableCosts?: boolean;
	currency?: any; // Direct currency object from parent
	isClientView?: boolean;
}

/**
 * Builds the InvoiceFormBase config for the AI quote-upload review form
 * (formType: 'proposal'). Shared by the buyer and supplier V2 quote pages —
 * quote currency always derives from the work order, and tax is a single number.
 */
export const createQuoteConfig = (
	formData: any,
	workOrder: any,
	currentUser: any,
	history: any,
	onSubmit: (values: any, formInstance: any, scope: string) => Promise<any>,
	options?: CreateQuoteConfigOptions
): InvoiceFormConfig => {
	return {
		formType: 'proposal',
		fields: {
			scope: true,
			invoiceNumber: false,
			externalWorkOrderId: false,
			invoiceDate: false,
			paymentTerms: false,
			dueDate: false,
			fileAttachments: true,
		},
		lineItemSections: [
			{ type: 'incurred', show: true, config: incurredConfig },
			{ type: 'labor', show: true, config: laborConfig },
			{ type: 'parts', show: true, config: partsConfig },
			{ type: 'equipment', show: true, config: equipmentConfig },
			{ type: 'travel', show: true, config: travelConfig },
			{ type: 'freight', show: true, config: freightConfig },
			{ type: 'misc', show: true, config: miscellaneousConfig },
		],
		tax: {
			type: 'lineItems',
			mode: 'single',
			...(isTaxExcludedFromQuotesByBuyer(workOrder) && {
				disabled: true,
				disabledReason: "Buyer doesn't want you to submit taxes for this quote!",
			}),
		},
		currency: {
			fetchInternally: !(options && options.currency),
			source: 'quote',
			value: options && options.currency,
		},
		onSubmit,
		formData,
		workOrder,
		currentUser,
		history,
		parsedDataSnapshot: options && options.parsedDataSnapshot,
		workOrderCheck: options && options.workOrderCheck,
		rawParsedData: options && options.rawParsedData,
		redirectForwardUrl: options && options.redirectForwardUrl,
		creating: options && options.creating,
		updating: options && options.updating,
		createErrors: options && options.createErrors,
		updateErrors: options && options.updateErrors,
		onSuccess: options && options.onSuccess,
		onError: options && options.onError,
		onReset: options && options.onReset,
		disableCosts: options && options.disableCosts,
		isClientView: options && options.isClientView,
	};
};
